import React, { ReactNode } from "react";
import styles from "./Parentcontainer.module.scss";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
// import BackgroundGreen from "../../assets/images/green-background.svg";
// import Lock from "../../assets/images/lock.svg";
// import { ReactComponent as MenuIcon } from "../../assets/images/show-details.svg";
// import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import {
//   openLoader,
//   closeLoader,
// } from "../../redux/actions/loader/loaderActions";

export default function ParentContainer({ children }: { children: ReactNode }) {
  // const [showDetails, setShowDetails] = useState(false);
  const useStyles = makeStyles({
    root: {
      // height: "647px",
      // width: "497px",
      margin: "0 auto",
      background: "white",
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "white",
      position: "relative",
    },
  });
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const [items, setItems] = useState<any>();

  // useEffect(() => {
  //   dispatch(openLoader());
  //   axios.get("./mockfolder/items.json").then((res: any) => {
  //     dispatch(closeLoader());
  //     setItems(res.data);
  //   });
  // }, []);

  return (
    <>
      {/* <Grid classes={{ root: classes.style }}>
        <Grid
          item
          // xs={12}
          // md={7}
          // xl={6}
          xs={12}
          md={5}
          xl={6}
          classes={{
            root: classes.root,
          }}
        >
          <div style={{ padding: "10px" }}>{children}</div>
        </Grid>
      </Grid> */}

      <div className={styles.parentcontainer}>
        <div className={styles.parentcontent}>{children}</div>
      </div>
    </>
  );
}
